import Constant from "../utils/constant";
import permissions from "../utils/permissions";

const side = [
  {
    id: 1,
    menu: "master",
    icon: Constant.MASTER,
    submenu: [
      {
        name: "Content Area",
        route: Constant.CONTENTS,
        icon: Constant.CONTENTS,
        permission: permissions.content_area_view,
      },
      {
        name: "Subject",
        route: Constant.SUBJECTS,
        icon: Constant.SUBJECTS,
        permission: permissions.subject_view,
      },
      {
        name: "Default Subjects",
        route: Constant.DEFAULT_SUBJECTS,
        icon: Constant.DEFAULT_SUBJECTS,
        permission: permissions.galaxy_subjects_view,
      },
      {
        name: "Domain",
        route: Constant.DOMAINS,
        icon: Constant.DOMAINS,
        permission: permissions.domain_view,
      },
      {
        name: "Standard",
        route: Constant.STANDARDS,
        icon: Constant.STANDARDS,
        permission: permissions.standard_view,
      },
      {
        name: "Standard Linking",
        route: Constant.STANDARDLINK,
        icon: Constant.STANDARDLINK,
        permission: permissions.standard_linking_view,
      },
      {
        name: "Standard Group",
        route: Constant.STANDARDGROUPS,
        icon: Constant.STANDARDGROUPS,
        permission: permissions.standard_group_view,
      },
      {
        name: "Question",
        route: Constant.QUESTION,
        icon: Constant.AUTHORQUESTION,
        permission: permissions.question_view,
      },
      {
        name: "Teacher Questions",
        route: Constant.TEACHER_QUESTION_LIST,
        icon: Constant.TEACHER_QUESTION_LIST,
        permission: permissions.teacher_questions_view,
      },
      {
        name: "Passage",
        route: Constant.PASSAGE,
        icon: Constant.PASSAGE,
        permission: permissions.passage_view,
      },
      {
        name: "Grade",
        route: Constant.GRADES,
        icon: Constant.GRADES,
        permission: permissions.grade_view,
      },
      {
        name: "Tag",
        route: Constant.TAGS,
        icon: Constant.TAGS,
        permission: permissions.tag_view,
      },
      {
        name: "Worksheet",
        route: Constant.WORKSHEETS,
        icon: Constant.WORKSHEETS,
        permission: permissions.worksheet_view,
      },
      {
        name: "Video",
        route: Constant.VIDEOS,
        icon: Constant.VIDEOS,
        permission: permissions.video_view,
      },
      {
        name: "Slides",
        route: Constant.SLIDES,
        icon: Constant.SLIDES,
        permission: permissions.slide_view,
      },
      {
        name: "Lesson Plans",
        route: Constant.LESSONPLANS,
        icon: Constant.LESSONPLANS,
        permission: permissions.lesson_plan_view,
      },
    ],
  },
  {
    id: 2,
    menu: "Skill Practice ",
    icon: Constant.SKILLS,
    submenu: [
      {
        name: "Skill Practice Subject",
        route: Constant.SKILLPRACTICESUBJECT,
        icon: Constant.SKILLPRACTICESUBJECT,
        permission: permissions.skill_practice_subject_view,
      },
      {
        name: "Skill Practice Standard",
        route: Constant.SKILLPRACTICESTANDARD,
        icon: Constant.SKILLPRACTICESTANDARD,
        permission: permissions.skill_practice_standard_view,
      },
      {
        name: "Skill Practice Question",
        route: Constant.SKILLPRACTICEQUESTION,
        icon: Constant.SKILLPRACTICEQUESTION,
        permission: permissions.skill_practice_subject_view,
      },
    ],
  },
  {
    id: 4,
    menu: "Supersheet",
    icon: Constant.WORKSHEETS,
    submenu: [
      {
        name: "Supersheet List",
        route: Constant.SUPERSHEETS,
        icon: Constant.WORKSHEETS,
        permission: permissions.worksheet_view,
      },
    ],
  },
  {
    id: 6,
    menu: "Canned Test",
    icon: Constant.CANNEDTEST,
    submenu: [
      {
        name: "Canned Test List",
        route: Constant.CANNEDTESTALL,
        icon: Constant.CANNEDTESTALL,
        permission: permissions.canned_test_view,
      },
    ],
  },
  {
    id: 7,
    menu: "Pricing",
    icon: Constant.PRICING,
    submenu: [
      {
        name: "Sellable product",
        route: Constant.SELLABLEPRODUCT,
        icon: Constant.SELLABLEPRODUCT,
        permission: permissions.sellable_product_view,
      },
      {
        name: "Bundle",
        route: Constant.BUNDLES,
        icon: Constant.BUNDLES,
        permission: permissions.bundle_view,
      },
    ],
  },
  {
    id: 8,
    menu: "Administration ",
    icon: Constant.SKILLS,
    submenu: [
      {
        name: "Permissions",
        route: Constant.PERMISSIONS,
        icon: Constant.PERMISSIONS,
        permission: permissions.permissions_view,
      },
      {
        name: "Permission Groups",
        route: Constant.PERMISSION_GROUPS,
        icon: Constant.PERMISSION_GROUPS,
        permission: permissions.permission_groups_view,
      },
      {
        name: "User Permissions",
        route: Constant.USER_PERMISSIONS,
        icon: Constant.USER_PERMISSIONS,
        permission: permissions.user_permissions_view,
      },
      {
        name: "Mini CRM",
        route: Constant.CRM,
        icon: Constant.CRM,
        permission: permissions.mini_crm_view,
      },
    ],
  },
  {
    id: 9,
    menu: "Utilities ",
    icon: Constant.Utilities,
    submenu: [
      {
        name: "Classify Cleanup",
        route: Constant.ClassifyCleanup,
        icon: Constant.ClassifyCleanup,
        permission: permissions.mini_crm_view,
      },
      {
        name: "Magic Match",
        route: Constant.STANDARDS_MAGIC_MATCH,
        icon: Constant.STANDARDS_MAGIC_MATCH,
        permission: permissions.mini_crm_view,
      },
      {
        name: "Learnosity Resubmit",
        route: Constant.LEARNOSITY_UTILS_RESUBMIT,
        icon: Constant.Utilities,
        permission: permissions.learnosity_resubmit_view,
      },
    ],
  },
];

export default side;
